import React from 'react';
import { Badge } from './ui/badge';

const CategoryBadge = ({ category, icon }) => {
  const getStyles = () => {
    switch (category) {
      case 'Truck Section':
        return 'text-amber-600 bg-amber-50 border-amber-200';
      case 'Machinery Section':
        return 'text-indigo-600 bg-indigo-50 border-indigo-200';
      case 'General':
        return 'text-slate-600 bg-slate-50 border-slate-200';
      default:
        return 'text-slate-600 bg-slate-50 border-slate-200';
    }
  };

  return (
    <Badge className={`${getStyles()} flex items-center gap-1.5`} data-testid={`category-badge-${category.toLowerCase().replace(' ', '-')}`}>
      {icon}
      {category}
    </Badge>
  );
};

export default CategoryBadge;
